
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.869 20.57l-1.093 1.917c-.18.316-.535.513-.922.513s-.742-.197-.921-.513L1.12 12.444a.886.886 0 010-.888L7.933 1.513c.179-.316.534-.513.92-.513.388 0 .743.197.923.513l1.093 1.916-1.175 1.662-.84-1.072-5.638 7.98 5.638 7.983.69-1.34 1.325 1.928zM23 12c0 .152-.04.304-.119.444L16.07 22.487c-.18.316-.535.513-.923.513-.387 0-.742-.197-.922-.513L7.412 12.444a.898.898 0 010-.888l6.812-10.043c.18-.316.535-.513.922-.513.388 0 .743.197.923.513l6.812 10.043c.08.14.12.292.12.444zm-2.216 0l-5.638-7.982L9.51 12l5.637 7.982L20.784 12z","fill":"#2A333D"}})])
          )
        }
      }
    